// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store' // 状态管理
import axios from '@/libs/http/axios'
import 'lib-flexible/flexible'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/scss/mint-ui-over.scss'
import 'babel-polyfill'
import FastClick from 'fastclick'
import jsBridge from '@/libs/jsBridge'
import '@/libs/global'

import utils from '@/libs/utils/utils'
import moment from 'moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import {Toast} from 'mint-ui'

// 判断时候是支付宝小程序环境，如果是动态加载web-view.min.js文件 Start
if (navigator.userAgent.indexOf('AlipayClient') > -1) {
    var scriptElement = document.createElement('script');
    document.body.appendChild(scriptElement);
    scriptElement.src = "https://appx/web-view.min.js"
}
// 判断时候是支付宝小程序环境，如果是动态加载web-view.min.js文件 End

import sensors from 'sa-sdk-javascript';
const sensorsProjectParams = `?project=${(location.href.indexOf('//app5.shouqiev.com') > -1 || location.href.includes('//app5share')) ? 'production' : 'default'}`;
const server_url = `https://gofunsaxcx.shouqiev.com/sa${sensorsProjectParams}`;
sensors.use('PageLeave');
sensors.init({
    server_url: server_url,
    heatmap: {
        //是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.7
        clickmap: 'not_collect', // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'not_collect'
    },
    show_log: true,
    is_track_single_page: true, //是否适配单页应用
});
console.log('server_url: ', server_url)
// 注册公共属性
const platform_type = (utils.getDataReport() && utils.getDataReport().os === 'android' ? 'Android' : 'iOS') || 'H5'
sensors.registerPage({
    platform_type,
    appName: 1,  // 枚举值：1GoFun出行、2 GoFun车服、3GoFun众包
});
const userId = utils.getUserId()
sensors.login(userId);
sensors.quick('autoTrack')
/** Fundebug Start **/
import fundebugVue from 'fundebug-vue';
if (location.href.indexOf('//app5.shouqiev.com') > -1) { //线上
    const fundebug = require("fundebug-javascript");
    fundebug.apikey = "5fc3f015e71ffa14418627a2463530bf6b48bca8dd497e36121ba91874ade17d";
    fundebugVue(fundebug, Vue);
    require("fundebug-revideo"); //从BUG 监控插件 1.7.3版本开始，我们拆分了录屏代码。如果需要使用录屏功能的话，需要单独接入录屏插件。
    if ("fundebug" in window) {
        fundebug.user = {
            name: utils && utils.getQueryString('userId') || '',
            email: utils && utils.getQueryString('orderId') || '',
        };
        fundebug.setHttpBody = true; //当 setHttpBody 设为 true 时，Fundebug 将会收集 HTTP 请求的 body 参数，并过滤掉 password 等隐私数据。
        fundebug.silentDev = true; //如果您不需要收集开发环境中的错误，则可以将 silentDev 属性设为 true
        // fundebug.filters = [
        //     {
        //         req: {
        //             url: /^((?!(growingio\.com|baidu\.com|report\.shouqiev\.com)).)*$/
        //         },
        //     }
        // ];
        fundebug.filters = [
            {
                target: {
                    src: /report.shouqiev.com/
                }
            },
            {
                target: {
                    src: /webapi.amap.com/
                }
            },
        ];
        fundebug.metaData = {
            user: {
                userId: utils && utils.getQueryString('userId') || '',
                token: window.token || '',
            },
            appInfo: {
                deviceId: utils && utils.getQueryString('deviceId') || '',
                deviceType: utils && utils.getQueryString('deviceType') || '',
                os: utils && utils.getQueryString('os') || '',
                versionId: utils && utils.getQueryString('versionId') || '',
                appVersion: utils && utils.getQueryString('appVersion') || '',
                cityCode: utils && utils.getQueryString('cityCode') || '',
                locationCityCode: utils && utils.getQueryString('locationCityCode') || '',
            },
        };
    }
}
/** Fundebug End **/

Vue.prototype.moment = moment
Vue.prototype.$http = axios
Vue.prototype.Prompt = utils.prompt
Vue.config.productionTip = false
Vue.use(Mint)
Vue.use(VueAwesomeSwiper)


import commonComponent from "../../components/common-component";

Vue.use(commonComponent);

// Vue.use(Echarts)
// Vue.use($)
/**
 * 路由发生变化根据router的meta.title修改页面title
 */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        if (to.query.reTitle) {
            document.title = to.query.reTitle
        } else {
            document.title = to.meta.title
        }
        //如果来源是H5Car，执行以下操作，改title和iframe的src
        if (top.h5car) {
            let newPath = ''
            newPath = '//' + top.location.host + '/iframeApp5' + '/dist/#' + to.fullPath
            if (process.env.NODE_ENV === 'testing') {
                newPath = '//' + top.location.host + '/h5app5' + '/dist/#' + to.fullPath
            }
            top.h5car.changeIframeUrl && top.h5car.changeIframeUrl(newPath)
            top.h5car.changeTitle && top.h5car.changeTitle(to.meta.title)
        }
    }
    //发票历史点击返回后不跳转到开票页面而是跳转到发票首页
    let toPath = to.path
    let fromPath = from.path
    if (toPath === '/invoiceByElectronicOrPaper' && fromPath === '/invoiceHistory') {
        next('/invoiceByTripOrCharge')
        return
    }
    if (_hmt) {
        //  自动PV跟踪，然后使用了_trackPageview接口来发送新的PV统计请求
        _hmt.push(['_setAutoPageview', false])
        var pageURL = '/#' + to.path
        _hmt.push(['_trackPageview', pageURL])
    }

    //GO券商城 登陆验证
    if (to.matched.some(record => record.meta.ticketRequiresAuth)) {
        let goFunToken = utils.getToken()
        if (!sessionStorage.ticketToken && !goFunToken) {
            if (!sessionStorage.ticketToken && goFunToken) {
                sessionStorage.ticketToken = goFunToken
            }
            console.log('ticketToken -----', sessionStorage.ticketToken)
            // window.native.showLoginView() //客户端登陆
            !navigator.userAgent.includes('gofun-app') && Toast('token不存在')
            jsBridge.showLoginView()
            return false
        } else {
            console.log('ticketToken ++++++')
            next()
        }
    }
    next()
})

router.afterEach((to, from) => {
    if (to.meta.title) {
        // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
        if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
            jsBridge.vueRouterDidFinishLoad()
        }
    }
})

//解决移动端300ms延迟
function fastClick() {
    const str = navigator.userAgent.toLowerCase()
    const ver = str.match(/cpu iphone os (.*?) like mac os/)
    if (!ver) {//非IOS系统
        // 引入fastclick 做相关处理
        FastClick.attach(document.body);
    } else {
        if (parseInt(ver[1]) < 11) {//ios11以下的版本判断
            // 引入fastclick 做相关处理
            FastClick.attach(document.body);
        }
    }
}

// fastClick()

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    },
})
// 微信环境初始化微信sdk
// if (utils.checkIsWeixin()) {
//     var oScript = document.createElement('script')
//     oScript.type = 'text/javascript';
//     oScript.async = true
//     oScript.src = "https://res.wx.qq.com/open/js/jweixin-1.0.0.js"
//     document.body.appendChild(oScript)
//     oScript.onload = function () {
//         Vue.jsonp("https://api.shouqiev.com/share/getJsApiInfoByJsonp.json?url="+encodeURIComponent(document.URL), {
//             callbackName:"getShareInfo",
//             callbackQuery: "callback"
//         })
//         .then (res => {
//             wx.config({
//                 debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//                 appId: res.weixinShare.appId, // 必填，公众号的唯一标识
//                 timestamp: res.weixinShare.timestamp, // 必填，生成签名的时间戳
//                 nonceStr: res.weixinShare.nonceStr, // 必填，生成签名的随机串
//                 signature: res.weixinShare.signature,// 必填，签名，见附录1
//                 jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','onMenuShareQZone','getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//             });
//             wx.ready(() => {
//                 const app = new Vue({
//                     el: '#app',
//                     router,
//                     store,
//                     template: '<App/>',
//                     components: {
//                         App
//                     },
//                 })
//             })
//         })
//     }
// } else {
//     const app = new Vue({
//         el: '#app',
//         router,
//         store,
//         template: '<App/>',
//         components: {
//             App
//         },
//     })
// }



// WEBPACK FOOTER //
// src/pages/index/index.js